export default __webpack_public_path__ + "static/media/CC01FD33-D6DA-4455-95C0-D4362C9E5636_1_105_c.7da4a855.jpeg";